import { CircularProgress } from "@mui/material";
import theme from "../../theme";
import Tooltip from "@mui/material/Tooltip";
import { memo, ReactNode } from "react";
import { useWindowSize } from "@reactuses/core";

const { md } = theme.screen;

interface Props {
  title: ReactNode | undefined;
  active?: boolean | undefined | null;
  children: JSX.Element;
  bgColor?: string;
}

/**
 * MUI Tooltip Customization
 *
 * @param title : 툴팁에 보여질 텍스트 또는 ReactNode (undefined인 경우 로딩 스피너)
 * @param active : 툴팁이 활성화되는 조건 (undefined | 인 경우 false)
 * @param children : 상호작용할 아이템
 * @param bgColor? : 배경색. 기본값 : theme의 tooltip color
 */
export const CustomTooltip = memo(
  ({
    title,
    active,
    children,
    bgColor = theme.statusColor.TOOLTIP,
    ...TooltipProps
  }: Props) => {
    const { width } = useWindowSize();
    return (
      <>
        <Tooltip
          disableHoverListener={!active}
          title={
            title ? (
              title
            ) : (
              <CircularProgress color={"inherit"} size={20} />
            )
          }
          arrow
          PopperProps={{
            sx: {
              "& .MuiTooltip-tooltip": {
                fontSize:
                  width > md
                    ? theme.fontSize.FONT_1
                    : theme.fontSize.FONT_3,
                fontWeight:
                  width > md
                    ? theme.fontWeight.BOLD
                    : theme.fontWeight.SEMI_BOLD,
              },
              "& .MuiTooltip-tooltipPlacementBottom": {
                backgroundColor: bgColor,
              },
              "& .MuiTooltip-arrow": {
                "&::before": {
                  backgroundColor: bgColor,
                },
              },
            },
          }}
          {...TooltipProps}
        >
          {children}
        </Tooltip>
      </>
    );
  }
);
